import keymirror from 'keymirror';
import { formatValidationTypeList } from 'sharedParts';
import { email, phone, number } from '../utils/formValidators';

const inputTypeList = keymirror({
  text: null,
  tel: null,
  number: null,
  email: null,
});

const formatValidationTypeToInputTypeMap = {
  [formatValidationTypeList.email]: inputTypeList.email,
};

export const getInputTypeFromFormatValidator = validationType =>
  formatValidationTypeToInputTypeMap[validationType] || inputTypeList.text;

export const formatValidationOptionList = [
  {
    value: formatValidationTypeList.none,
    label: 'Do not validate',
  },
  {
    value: formatValidationTypeList.number,
    label: 'Number',
  },
  {
    value: formatValidationTypeList.phone,
    label: 'Phone number',
  },
  {
    value: formatValidationTypeList.email,
    label: 'Email',
  },
];

export const formatValidationMap = {
  [formatValidationTypeList.none]: null,
  [formatValidationTypeList.number]: number,
  [formatValidationTypeList.phone]: phone,
  [formatValidationTypeList.email]: email,
};
